$( document ).ready( function() {
    function openHashPopup() {
        const hash = window.location.hash;

        // only proceed if hash exists AND matches an element
        if (hash && $(hash).length > 0) {
        $.magnificPopup.open({
            items: { src: hash },
            type: 'inline',
            midClick: true
        });
        }
    }

    // open on initial page load
    openHashPopup();

    $(".popup-modal").magnificPopup({
      type: "inline",
      preloader: false,
      closeOnBgClick: true,
      callbacks: {
        open: function() {
            // Initialize Swiper when popup opens
            new Swiper('.mfp-wrap .author-swiper', {
                loop: true,
                spaceBetween: 15,
                pagination: {
                    el: '.mfp-wrap .swiper-pagination',
                    clickable: true,
                }
            });
        }
    }
    });
    $(document).on("click", ".popup-modal-dismiss", function (e) {
        e.preventDefault();
        $.magnificPopup.close();
    });
});